module.exports = __webpack_public_path__ + "img/coupon-gift-left-one.ad64164.png";